module.exports = __webpack_public_path__ + "img/arrows-with-focus.42bccf9b.png";